/**
 * Eid Al Etihad 55 product data. Single source of truth: the collection grid,
 * the customize form and the header menu (desktop dropdown + mobile drawer) all
 * read from SCARVES, so adding an entry here (plus its
 * /public/eid55/scarves/scarf-N.png image) surfaces it everywhere.
 */

export const EID55_PATH = "/eid-al-etihad";

export type EidScarf = {
  tint: string;
  dot: string;
  en: [string, string];
  ar: [string, string];
};

export const SCARVES: EidScarf[] = [
  {
    tint: "#F3F0E8",
    dot: "#FFFFFF",
    en: ["City streets", "White with everyday street life"],
    ar: ["شوارع المدينة", "أبيض بمشاهد الحياة اليومية"],
  },
  {
    tint: "#E2D6E4",
    dot: "#C9B6CC",
    en: ["The parade", "Lilac with balloons and the flag car"],
    ar: ["المسيرة", "ليلكي بالبالونات وسيارة العلم"],
  },
  {
    tint: "#F1C9AE",
    dot: "#D9824F",
    en: ["Ayyala & flags", "Coral with ghaf trees and dancers"],
    ar: ["العيّالة والأعلام", "مرجاني بأشجار الغاف والعيّالة"],
  },
  {
    tint: "#EFE9D8",
    dot: "#E9E2CF",
    en: ["Heritage homes", "Sand with houses and the arch"],
    ar: ["البيوت التراثية", "رملي بالبيوت والبوابة"],
  },
  {
    tint: "#D9EBF2",
    dot: "#CBE3EF",
    en: ["Coast & dhows", "Sky blue with dhows and bougainvillea"],
    ar: ["الساحل والقوارب", "سماوي بالقوارب والجهنمية"],
  },
  {
    tint: "#BFE0DA",
    dot: "#1F9A8C",
    en: ["Those who serve", "Teal with the armed forces"],
    ar: ["حماة الوطن", "تركوازي بالقوات المسلحة"],
  },
  {
    tint: "#FBE8B6",
    dot: "#F7D57D",
    en: ["Desert camp", "Yellow with the tent and horses"],
    ar: ["المخيّم", "أصفر بالخيمة والخيول"],
  },
  {
    tint: "#D3E2C8",
    dot: "#5E844F",
    en: ["Oasis wildlife", "Olive with trees and animals"],
    ar: ["حياة الواحة", "زيتي بالأشجار والحيوانات"],
  },
  {
    tint: "#F8D3B6",
    dot: "#EE9050",
    en: ["Dunes & camels", "Orange with the desert and camels"],
    ar: ["الكثبان والجمال", "برتقالي بالصحراء والجمال"],
  },
];

export type EidMenuEntry = { label: string; to: string };

/** Menu entries (language prefix NOT included; callers add it with lp()). */
export const eidMenuEntries = (lang: "en" | "ar"): EidMenuEntry[] =>
  SCARVES.map((s, i) => ({
    label: s[lang][0],
    to: `${EID55_PATH}?design=${i + 1}`,
  }));
